export default __webpack_public_path__ + "static/media/cellphone.200d2b2d.png";